import { render, staticRenderFns } from "./RegularPayFailed.vue?vue&type=template&id=90cb07da&"
import script from "./RegularPayFailed.vue?vue&type=script&lang=js&"
export * from "./RegularPayFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports